import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, BeneficiaryDTO, CreateBeneficiaryPayload} from '@sollapay/types';

export const beneficiariesApi = {
  fetchBeneficiaries: async (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<BeneficiaryDTO[]>> => {
    return client.get<ApiResponse<BeneficiaryDTO[]>>(
      `/trust_accounts/${trustAccountId}/beneficiaries`
    );
  },
  createBeneficiary: async (
    client: HttpClient,
    trustAccountId: string,
    payload: CreateBeneficiaryPayload
  ): Promise<ApiResponse<BeneficiaryDTO>> => {
    return client.post<ApiResponse<BeneficiaryDTO>>(
      `/trust_accounts/${trustAccountId}/beneficiaries`,
      payload
    );
  },
  updateBeneficiary: async (
    client: HttpClient,
    trustAccountId: string,
    partyId: string,
    payload: CreateBeneficiaryPayload
  ): Promise<ApiResponse<BeneficiaryDTO>> => {
    return client.patch<ApiResponse<BeneficiaryDTO>>(
      `/trust_accounts/${trustAccountId}/beneficiaries/${partyId}`,
      payload
    );
  },
  deleteBeneficiary: async (
    client: HttpClient,
    trustAccountId: string,
    partyId: string
  ): Promise<void> => {
    return client.delete<void>(`/trust_accounts/${trustAccountId}/beneficiaries/${partyId}`);
  }
};
